export default "__VITE_ASSET__BMCiy7Fj__"